/** Пустая корзина с крестиком — иллюстрация пустого состояния корзины. */
export const EmptyCartIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      opacity="0.5"
      d="M10.4184 13.7562C11.1053 11.8024 13.246 10.7754 15.1999 11.4623L16.7069 11.9921C19.7895 13.0758 22.4077 13.9962 24.4681 15.0072C26.6713 16.0882 28.5605 17.4199 29.9814 19.4992C31.3913 21.5624 31.9734 23.826 32.242 26.3079C32.3623 27.4189 32.4257 28.6486 32.4592 30.0002H85.6505C94.075 30.0002 101.659 30.0002 103.878 32.8856C106.098 35.7711 105.23 40.1187 103.495 48.814L100.996 60.9377C99.4205 68.5822 98.633 72.4042 95.874 74.6522C93.1155 76.9002 89.213 76.9002 81.408 76.9002H54.8935C40.9489 76.9002 33.9767 76.9002 29.6447 72.3312C25.3127 67.7617 24.9965 62.9082 24.9965 48.2002V35.1918C24.9965 31.4921 24.9914 29.016 24.7856 27.115C24.5889 25.2982 24.2404 24.3911 23.7891 23.7307C23.3488 23.0864 22.6805 22.4842 21.1644 21.7403C19.5501 20.9483 17.3564 20.1705 14.0183 18.9969L12.7123 18.5377C10.7585 17.8508 9.73144 15.7101 10.4184 13.7562Z"
      fill="#2BB747"
    />
    <path
      d="M60.1514 44.8483C58.6869 43.3839 56.3129 43.3839 54.8484 44.8483C53.3839 46.3128 53.3839 48.6872 54.8484 50.1515L59.6964 55L54.8484 59.8485C53.3839 61.313 53.3839 63.687 54.8484 65.1515C56.3129 66.616 58.6869 66.616 60.1514 65.1515L64.9999 60.3035L69.8484 65.1515C71.3129 66.616 73.6869 66.616 75.1514 65.1515C76.6159 63.687 76.6159 61.313 75.1514 59.8485L70.3034 55L75.1514 50.1515C76.6159 48.6872 76.6159 46.3128 75.1514 44.8483C73.6869 43.3839 71.3129 43.3839 69.8484 44.8483L64.9999 49.6967L60.1514 44.8483Z"
      fill="#2BB747"
    />
    <path
      d="M37.5 90C41.6421 90 45 93.358 45 97.5C45 101.642 41.6421 105 37.5 105C33.3579 105 30 101.642 30 97.5C30 93.358 33.3579 90 37.5 90Z"
      fill="#2BB747"
    />
    <path
      d="M82.5 90.0005C86.642 90.0005 90 93.358 90 97.5005C90 101.642 86.642 105 82.5 105C78.358 105 75 101.642 75 97.5005C75 93.358 78.358 90.0005 82.5 90.0005Z"
      fill="#2BB747"
    />
  </svg>
);
